import React from "react";

export const HeaderNav: React.FC = () => {
  return <h2>Pick list</h2>;
};

export default HeaderNav;
